export function isSerializable(value) {
    if (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        value === null ||
        typeof value === 'undefined') {
        return true;
    }
    if (typeof value !== 'object') {
        return false;
    }
    if (Array.isArray(value)) {
        return value.every(isSerializable);
    }
    const valueAsRecord = value;
    // eslint-disable-next-line no-restricted-syntax -- We do want to iterate over the entire prototype chain
    for (const key in valueAsRecord) {
        if (!isSerializable(valueAsRecord[key])) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=types.js.map